import { createContext, useContext } from 'react';

export interface AuthStateValue {
  isAuthenticated: boolean;
  isLoading: boolean;
  /** `returnTo` rides through the IdP as OIDC url_state — see `auth/returnTo.ts`. */
  signinRedirect: (returnTo?: string) => void;
  signoutRedirect: () => void;
  /** Where a completed login should land, when it interrupted a request for a specific page. */
  returnTo?: string;
}

export const AuthStateContext = createContext<AuthStateValue | null>(null);

export function useAuthState(): AuthStateValue {
  const ctx = useContext(AuthStateContext);
  if (!ctx) throw new Error('useAuthState must be used within <AuthProvider>');
  return ctx;
}
